import React from "react";
import { ABOUT } from "../../../container/Constants";

const Discription = () => {
  return (
    <div className="discription">
      <div>
        <div className="paragraph-container">
          {ABOUT.map((para, idx) => (
            <p key={idx}>{para}</p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Discription;
